import AccountSource from 'src/models/accounting/AccountSource'
import Model, { ID, Integer, JsonArray, MODEL_LEVEL } from 'src/models/Model'

export const ACCOUNT_TYPES = {
  ASSET: 'asset',
  EXPENSE: 'expense',
  LIABILITY: 'liability',
  EQUITY: 'equity',
  REVENUE: 'revenue'
}
export const DEBITS_ACCOUNT_TYPES = [ACCOUNT_TYPES.ASSET, ACCOUNT_TYPES.EXPENSE]
export const CREDITS_ACCOUNT_TYPES = [ACCOUNT_TYPES.LIABILITY, ACCOUNT_TYPES.EQUITY, ACCOUNT_TYPES.REVENUE]

export const ACCOUNT_ROLE = {
  SALES_TAX_PAYABLE: 'sales_tax_payable',
  UNEARNED_REVENUE: 'unearned_revenue',
  ACCOUNTS_RECEIVABLE: 'accounts_receivable',
  OTHER: 'other'
}

export default class Account extends Model {
  static name = 'Account'

  static deletable = true

  static versioned = true

  static paginate = true

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Financial]

  static define () {
    this.fields = {
      id: {
        type: ID,
        sortable: true,
        required: true
      },

      name: {
        type: String,
        sortable: true,
        default: null
      },
      type: {
        type: String,
        default: null,
        options: _.values(ACCOUNT_TYPES)
      },
      role: {
        type: String,
        default: null,
        options: _.values(ACCOUNT_ROLE)
      },
      glCode: {
        type: String,
        default: null
      },

      displayOrder: {
        type: Integer,
        default: 999
      },

      accountSources: {
        type: [AccountSource],
        default: () => ([]),
        allowDestroy: true,
        acceptsNestedAttributes: true
      },
      libraryParentId: {
        type: ID,
        output: true,
        excludeFromDefault: true
      },
      receiveLibraryUpdates: {
        type: Boolean,
        excludeFromDefault: true
      },
      libraryChildSiteIds: {
        type: [ID],
        output: true,
        excludeFromDefault: true
      },
      libraryDescendantSites: {
        type: JsonArray,
        output: true,
        excludeFromDefault: true
      },
      action: {
        type: String,
        input: true
      }
    }
  }
}
